const whatsappUrl = 'https://wa.me/905077089198?text=Merhaba%2C%20V%C4%B0AYP%C4%B0%C4%B0%20Temizlik%20i%C3%A7in%20teklif%20almak%20istiyorum.%20Temizlenecek%20alan%C4%B1n%20videosunu%20g%C3%B6ndermek%20istiyorum.';

export default function MobileBar() {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-warm-sand shadow-lg md:hidden pb-safe">
      <div className="max-w-7xl mx-auto px-4 py-3">
        <a
          href={whatsappUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center gap-3 w-full px-4 py-3 bg-gold hover:bg-gold-dark text-navy-dark font-bold text-base rounded-md transition-colors"
        >
          <i className="ri-whatsapp-line text-xl"></i>
          WhatsApp'tan Teklif Al
        </a>
      </div>
    </div>
  );
}